(() => {
  "use strict";

  const input = document.querySelector("[data-photo-input]");
  const uploadDialog = document.querySelector("[data-upload-review-dialog]");
  const uploadReview = uploadDialog?.querySelector(".upload-review-dialog__media img");
  let reviewUrl = "";
  let pendingFile = null;

  function clearReviewUrl() {
    if (reviewUrl) URL.revokeObjectURL(reviewUrl);
    reviewUrl = "";
  }

  function closeUploadReview({ clearInput = false, chooseAnother = false } = {}) {
    if (uploadDialog?.open) uploadDialog.close();
    clearReviewUrl();
    pendingFile = null;
    if (clearInput && input) input.value = "";
    if (chooseAnother) input?.click();
  }

  function openUploadReview(file) {
    if (!uploadDialog || !uploadReview || !file) return;
    pendingFile = file;
    clearReviewUrl();
    reviewUrl = URL.createObjectURL(file);
    uploadReview.src = reviewUrl;
    if (uploadDialog.open) uploadDialog.close();
    try {
      uploadDialog.showModal();
    } catch {
      uploadDialog.setAttribute("open", "");
    }
  }

  input?.addEventListener("change", () => {
    const file = input.files?.[0];
    if (file) openUploadReview(file);
  });
  uploadDialog?.querySelector("[data-upload-review-close]")?.addEventListener("click", () => closeUploadReview({ clearInput: true }));
  uploadDialog?.querySelector("[data-upload-review-change]")?.addEventListener("click", () => closeUploadReview({ clearInput: true, chooseAnother: true }));
  uploadDialog?.addEventListener("cancel", (event) => {
    event.preventDefault();
    closeUploadReview({ clearInput: true });
  });
  uploadDialog?.querySelectorAll("[data-upload-review-generate]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!pendingFile) return;
      const file = pendingFile;
      const mode = button.dataset.uploadReviewGenerate === "enhanced" ? "enhanced" : "quick";
      if (uploadDialog.open) uploadDialog.close();
      clearReviewUrl();
      pendingFile = null;
      input.dispatchEvent(new CustomEvent("formofus:photo-confirmed", { detail: { file, mode } }));
      document.querySelector("[data-generate-button]")?.focus();
    });
  });

  const thumbs = document.querySelector("[data-product-thumbs]");
  const mainImage = document.querySelector("[data-product-image]");
  const galleryStory = document.querySelector("[data-gallery-story]");
  thumbs?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-gallery-image]");
    if (!button || !mainImage) return;
    mainImage.src = button.dataset.galleryImage;
    mainImage.alt = button.dataset.galleryAlt || mainImage.alt;
    thumbs.querySelectorAll("button").forEach((item) => item.classList.toggle("active", item === button));
    if (galleryStory) {
      const title = button.dataset.galleryTitle || "";
      const body = button.dataset.galleryBody || "";
      galleryStory.hidden = !title;
      galleryStory.querySelector("[data-gallery-title]").textContent = title;
      galleryStory.querySelector("[data-gallery-body]").textContent = body;
    }
  });

  const lightbox = document.querySelector("[data-image-lightbox]");
  document.querySelector("[data-image-zoom]")?.addEventListener("click", () => {
    if (!lightbox || !mainImage) return;
    lightbox.querySelector("img").src = mainImage.src;
    lightbox.showModal();
  });
  document.querySelector("[data-image-lightbox-close]")?.addEventListener("click", () => lightbox.close());

  const customizeBox = document.querySelector(".customization-box");
  document.querySelectorAll("[data-sticky-customize], [data-scroll-customize]").forEach((button) => button.addEventListener("click", () => {
    customizeBox?.scrollIntoView({ behavior: "smooth", block: "center" });
  }));

  const menuToggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("#primary-nav");
  menuToggle?.addEventListener("click", () => {
    const open = nav?.classList.toggle("open");
    menuToggle.setAttribute("aria-expanded", String(Boolean(open)));
  });

  const searchDialog = document.querySelector("[data-search-dialog]");
  document.querySelector("[data-search-open]")?.addEventListener("click", () => searchDialog?.showModal());

  const benefitShowcase = document.querySelector("[data-benefit-showcase]");
  if (benefitShowcase) {
    const tabs = [...benefitShowcase.querySelectorAll("[data-benefit-tab]")];
    const icon = benefitShowcase.querySelector("[data-benefit-icon]");
    const title = benefitShowcase.querySelector("[data-benefit-title]");
    const body = benefitShowcase.querySelector("[data-benefit-body]");
    let activeIndex = 0;
    let rotationTimer = null;

    const activateBenefit = (index, { focus = false } = {}) => {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === activeIndex;
        tab.classList.toggle("active", active);
        tab.setAttribute("aria-selected", String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      const activeTab = tabs[activeIndex];
      if (icon) icon.textContent = activeTab.dataset.icon || "✦";
      if (title) title.textContent = activeTab.dataset.title || activeTab.textContent.trim();
      if (body) body.textContent = activeTab.dataset.body || "";
      if (focus) activeTab.focus();
    };
    const stopRotation = () => {
      if (rotationTimer) window.clearInterval(rotationTimer);
      rotationTimer = null;
    };
    const startRotation = () => {
      stopRotation();
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      rotationTimer = window.setInterval(() => activateBenefit(activeIndex + 1), 3600);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateBenefit(index);
        startRotation();
      });
      tab.addEventListener("keydown", (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        activateBenefit(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), { focus: true });
        startRotation();
      });
    });
    benefitShowcase.addEventListener("mouseenter", stopRotation);
    benefitShowcase.addEventListener("mouseleave", startRotation);
    benefitShowcase.addEventListener("focusin", stopRotation);
    benefitShowcase.addEventListener("focusout", startRotation);
    activateBenefit(0);
    startRotation();
  }

  const recommendations = document.querySelector("[data-recommendations]");
  if (recommendations) {
    const filters = [...recommendations.querySelectorAll("[data-recommendation-filter]")];
    const cards = [...recommendations.querySelectorAll("[data-recommendation-card]")];
    const currentHandle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || "";
    const applyRecommendationFilter = (filter) => {
      filters.forEach((button) => {
        const active = button.dataset.recommendationFilter === filter;
        button.classList.toggle("active", active);
        button.setAttribute("aria-selected", String(active));
      });
      cards.forEach((card) => {
        const groups = String(card.dataset.recommendationGroup || "").split(/\s+/);
        const isCurrent = card.dataset.productHandle === currentHandle;
        card.hidden = isCurrent || !groups.includes(filter);
      });
    };
    filters.forEach((button) => button.addEventListener("click", () => applyRecommendationFilter(button.dataset.recommendationFilter)));
    applyRecommendationFilter("keepsake");
  }

})();
